export default "__VITE_ASSET__D7C23wMK__"